export default __webpack_public_path__ + "static/media/0009.005d8465.jpg";